import React from 'react';

const Schools = () => {
  return (
    <iframe
      src="https://iframe.krgsc.kz/schools"
      title="Schools"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default Schools;
